<template>
  <div>
    <b-row>
      <b-col cols="1"></b-col>
      <b-col cols="3">
        <br />
        <v-select
          :searchable="true"
          :clearable="true"
          label="company_name"
          code="id"
          v-model="selectedCompany"
          :options="response.companyList"
          @input="changeCompany"
        ></v-select>
      </b-col>
      <b-col cols="4">
        <h1>Reports</h1>
      </b-col>
      <b-col cols="3">
        <br />
        <date-range-picker
          ref="picker"
          :opens="opens"
          :locale-data="locale"
          :singleDatePicker="false"
          :timePicker="false"
          :timePicker24Hour="true"
          :showWeekNumbers="false"
          :showDropdowns="true"
          :autoApply="false"
          :ranges="ranges"
          v-model="dateRange"
          @toggle="checkOpen"
          @update="updateValues"
          :linkedCalendars="true"
        >
          <div
            slot="input"
            slot-scope="picker"
            style="min-width: 350px;"
          >{{ picker.startDate | date }} - {{ picker.endDate | date }}</div>
        </date-range-picker>
      </b-col>
      <b-col cols="1">
        <b-button variant="outline-success mt-4" @click="downloadReport()">
          <font-awesome-icon icon="download" />
        </b-button>
      </b-col>
    </b-row>
    <div v-if="isLoading">
      <b-spinner type="grow" label="Loading..."></b-spinner>
    </div>
    <b-tabs content-class="mt-3" v-else>
      <b-tab title="Stats" active>
        <div style="height:580px; overflow-y:auto;">
          <h1 class="text-center">{{response.clientModel.company_name || ''}}</h1>
          <p class="text-center">as of {{date_of_report}}</p>
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>Number of Third parties uploaded on the platform by {{response.clientModel.company_name || ''}}</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Total</td>
                    <td>{{response.thirdPartiesCount}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Total Third parties uploaded from {{(formatDateTime(response.startDate))}} to {{(formatDateTime(response.endDate))}}</td>
                    <td>{{response.totalNumberOfThirdPartiesWithDateFilter}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>Ordered from {{(formatDateTime(response.startDate))}} to {{(formatDateTime(response.endDate))}}</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>No. of IDD+</td>
                    <td>{{response.totalNumberOfThirdPartiesIDDOrdersWithDateFilter}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>No. of EDD</td>
                    <td>{{response.totalNumberOfThirdPartiesEDDOrdersWithDateFilter}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4">
              <b-card header="Show IDD & EDD" class="mb-2">
                <b-card-body style="height:250px;" class="p-0">
                  <ChartComponent
                    :id="'oveiver'"
                    :type="'pie'"
                    :labels="pieChartLabels.showEddAndIddPlus"
                    :dataset="pieChartDatasets"
                    :options="pieChartOptions"
                  />
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>Sanctions and Enforcement Results</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>No Risk Alert Found</td>
                    <td>{{response.totalThirdPartiesSanctionsWithNoRiskAlert}}</td>
                    <td>{{noRiskAlertFound | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Risk Alert Found</td>
                    <td>{{response.totalThirdPartiesSanctionsWithRiskAlert}}</td>
                    <td>{{riskAlertFound | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>{{response.totalThirdPartiesSanctionsWithNoRiskAlert + response.totalThirdPartiesSanctionsWithRiskAlert}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4">
              <b-card header="Show Risk Alert Found" class="mb-2">
                <b-card-body style="height:250px;" class="p-0">
                  <ChartComponent
                    :id="'oveiver1'"
                    :type="'pie'"
                    :labels="pieChartLabels.showRiskAlert"
                    :dataset="pieChartDatasets"
                    :options="pieChartOptions"
                  />
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>Predictive Risk Indicator</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Low Risk</td>
                    <td>{{response.thirdPartiesWithLowPRICount}}</td>
                    <td>{{lowRiskPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Moderate Risk</td>
                    <td>{{response.thirdPartiesWithModeratePRICount}}</td>
                    <td>{{moderateRiskPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>High Risk</td>
                    <td>{{response.thirdPartiesWithHighPRICount}}</td>
                    <td>{{highRiskPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>No PRI</td>
                    <td>{{response.thirdPartiesWithNoPRICount}}</td>
                    <td>{{noPriPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>{{response.thirdPartiesCount}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>EDD Reports: All EDD Reports includes IDD Plus for Ongoing Monitoring purposes</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Green EDD Risk Color</td>
                    <td>{{response.thirdPartiesWithGreenEDD}}</td>
                    <td>{{greenEddRiskPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Red EDD Risk Color</td>
                    <td>{{response.thirdPartiesWithRedEDD}}</td>
                    <td>{{redEddRiskPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>{{response.thirdPartiesWithEddOrders}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>EDD Results across overall Third Party population</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Total Number of Third Parties Uploaded</td>
                    <td>{{response.thirdPartiesCount}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Total EDD ordered</td>
                    <td>{{response.thirdPartiesWithEddOrders}}</td>
                    <td>{{eddOrdersPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Total EDDs with Alerts</td>
                    <td>{{response.thirdPartiesWithRedEDD}}</td>
                    <td>{{eddOrdersWithAlertsPercentage | convertToFloat}}</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>
                      IDD Plus Reports:
                      IDD+ screening covers over 400 Sanctions, Enforcements and Watchlists as well as Politically Exposed Persons (PEP) and over 6 million Adverse Media records
                    </th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Total Number of Third Parties Uploaded</td>
                    <td>{{response.thirdPartiesCount}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>IDD Plus Ordered</td>
                    <td>{{response.thirdPartiesWithIddOrders}}</td>
                    <td>{{iddOrdersPercentage | convertToFloat}}</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>IDD Plus Results across overall Third Party population</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Total Number of Third Parties Uploaded</td>
                    <td>{{response.thirdPartiesCount}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Total IDD+ ordered</td>
                    <td>{{response.thirdPartiesWithIddOrders}}</td>
                    <td>{{iddOrdersPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Total IDD+ with Alerts</td>
                    <td>{{response.thirdPartiesWithIddOrdersWithAlerts}}</td>
                    <td>{{iddOrdersWithAlertPercentage | convertToFloat}}</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>IDD Plus Risk Summary (From {{response.thirdPartiesWithIddOrders}} IDD Plus ordered)</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Green IDD Plus Risk Color</td>
                    <td>{{response.thirdPartiesWithIddOrdersWithGreenIdd}}</td>
                    <td>{{iddOrdersGreenPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Red IDD Plus Risk Color</td>
                    <td>{{response.thirdPartiesWithIddOrdersWithRedIdd}}</td>
                    <td>{{iddOrdersRedPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Total IDD+ with Alerts</td>
                    <td>{{response.thirdPartiesWithIddOrdersWithAlerts}}</td>
                    <td>{{iddOrdersWithAlertPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>{{response.thirdPartiesWithIddOrders}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>IDD Plus Alerts Remediation (From {{response.thirdPartiesWithIddPlusRedAlertsRemediation}} Red IDD Plus)</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Remediation ordered</td>
                    <td>{{response.thirdPartiesWithIddPlusRemediationOrdered}}</td>
                    <td>{{iddPlusRemediationPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Remediation not ordered</td>
                    <td>{{response.thirdPartiesWithIddPlusRemediationNotOrdered}}</td>
                    <td>{{iddPlusRemediationNotOrderedPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>{{response.thirdPartiesWithIddPlusRedAlertsRemediation}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>IDD Plus Risk Remediation Summary (From {{response.thirdPartiesWithIddPlusRemediationOrdered}} Remediations ordered)</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Green IDD+ Risk Color</td>
                    <td>{{response.thirdPartiesWithIddPlusRemediationGreen}}</td>
                    <td>{{iddPlusRemediationGreenPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>Red IDD+ Risk Color</td>
                    <td>{{response.thirdPartiesWithIddPlusRemediationRed}}</td>
                    <td>{{iddPlusRemediationRedPercentage | convertToFloat}}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>{{response.thirdPartiesWithIddPlusRemediationOrdered}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>Ongoing Monitoring alerts: {{lastTwoMonthData}}</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Number of TPs with Alerts (Pre-Remediation)</td>
                    <td>{{response.thirdPartiesWithAlertsWithPreRemediationLastTwoMonth}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Number of TPs with Alerts (Post-Remediation)</td>
                    <td>{{response.thirdPartiesWithAlertsWithPostRemediationLastTwoMonth}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Number of Alerts (Pre-Remediation)</td>
                    <td>{{response.thirdPartiesTotalAlertsWithPreRemediationLastTwoMonth}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Number of Alerts (Post-Remediation)</td>
                    <td>{{response.thirdPartiesTotalAlertsWithPostRemediationLastTwoMonth}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>Ongoing Monitoring alerts: {{lastMonthData}}</th>
                    <th>No.</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Number of TPs with Alerts (Pre-Remediation)</td>
                    <td>{{response.thirdPartiesWithAlertsWithPreRemediationLastMonth}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Number of TPs with Alerts (Post-Remediation)</td>
                    <td>{{response.thirdPartiesWithAlertsWithPostRemediationLastMonth}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Number of Alerts (Pre-Remediation)</td>
                    <td>{{response.thirdPartiesTotalAlertsWithPreRemediationLastMonth}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Number of Alerts (Post-Remediation)</td>
                    <td>{{response.thirdPartiesTotalAlertsWithPostRemediationLastMonth}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="8">
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>Ongoing Monitoring alerts: All Time</th>
                    <th>No.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Number of TPs with Alerts</td>
                    <td>{{response.thirdPartiesWithAlertsWithPreRemediationAll}}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Number of Alerts</td>
                    <td>{{response.thirdPartiesTotalAlertsWithPreRemediationAll}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab title="Third Parties">
        <div style="height:570px; overflow-y:auto;">
          <h4 class="text-center">{{response.clientModel.company_name || ''}}</h4>
          <!-- <div class="text-center">{{response.clientModel.contact_name || ''}}</div> -->
          <!-- <div style="width:500px; overflow-y:auto;margin-left:auto; margin-right:auto;">{{response.clientModel.contact_email}}</div> -->
          <b-row>
            <b-col cols="12">
              <ThirdPartiesVueContainer :moreParams="thirdPartiesVueContainerParams" />
            </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab title="Reports">
        <div style="height:560px; overflow-y:auto;">
          <b-tabs content-class="mt-3">
            <b-tab title="IDD+ COUNTER" active>
              <b-row>
                <b-col cols="12">
                  <IddPlusCounterVueContainer :moreParams="ajaxPostParameters" />
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="REMEDIATED IDD+ COUNTER">
              <b-row>
                <b-col cols="12">
                  <RemediatedIddPlusCounterVueContainer :moreParams="ajaxPostParameters" />
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="EDD COUNTER">
              <b-row>
                <b-col cols="12">
                  <EddCounterVueContainer :moreParams="ajaxPostParameters" />
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-tab>
      <b-tab title="OGM Alerts">
        <div style="height:560px; overflow-y:auto;">
          <b-row>
            <b-col cols="12">
              <OgmAlertsVueContainer :moreParams="ajaxPostParameters" />
            </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab title="OGM Remediation">
        <div style="height:560px; overflow-y:auto;">
          <b-row>
            <b-col cols="12">
              <OgmRemediationVueContainer :moreParams="ajaxPostParameters" />
            </b-col>
          </b-row>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import ChartComponent from "../components/charts/chart";
import moment from "moment";
import axios from "axios";
import config from "./../configs/config";
import ThirdPartiesVueContainer from "../containers/ThirdPartiesVueContainer.vue";
import IddPlusCounterVueContainer from "../containers/IddPlusCounterVueContainer.vue";
import RemediatedIddPlusCounterVueContainer from "../containers/RemediatedIddPlusCounterVueContainer.vue";
import EddCounterVueContainer from "../containers/EddCounterVueContainer.vue";
import OgmAlertsVueContainer from "../containers/OgmAlertsVueContainer.vue";
import OgmRemediationVueContainer from "../containers/OgmRemediationVueContainer.vue";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import {
//     Helper
// } from "../helpers";

import { HTTP } from "../utils/HTTP";
export default {
  components: {
    //   WebApi,
    ChartComponent,
    ThirdPartiesVueContainer,
    IddPlusCounterVueContainer,
    RemediatedIddPlusCounterVueContainer,
    EddCounterVueContainer,
    OgmAlertsVueContainer,
    OgmRemediationVueContainer,
    DateRangePicker
  },
  data() {
    return {
      response: [],
      isLoading: false,
      selectedCompany: "Select Company",
      thirdPartiesVueContainerParams: {},
      opens: "left",
      locale: {
        direction: "ltr", //direction of text
        format: "DD-MM-YYYY", //fomart of the dates displayed
        separator: " - ", //separator between the two ranges
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1 //ISO first day of week - see moment documenations for details
      },
      dateRange: {
        startDate: moment()
          .subtract(1, "months")
          .startOf("month"),
        endDate: moment()
          .subtract(1, "months")
          .endOf("month")
      },
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "This month": [moment().startOf("month"), moment().endOf("month")],
        "This year": [moment().startOf("year"), moment().endOf("year")],
        "Last week": [
          moment()
            .subtract(1, "week")
            .startOf("week"),
          moment()
            .subtract(1, "week")
            .endOf("week")
        ],
        "Last month": [
          moment()
            .subtract(1, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month")
        ]
      },
      date_of_report: "",
      noRiskAlertFound: "0",
      riskAlertFound: "0",
      lowRiskPercentage: "0",
      moderateRiskPercentage: "0",
      highRiskPercentage: "0",
      noPriPercentage: "0",
      greenEddRiskPercentage: "0",
      redEddRiskPercentage: "0",
      eddOrdersPercentage: "0",
      eddOrdersWithAlertsPercentage: "0",
      iddOrdersPercentage: "0",
      iddOrdersWithAlertPercentage: "0",
      iddOrdersGreenPercentage: "0",
      iddOrdersRedPercentage: "0",
      iddPlusRemediationPercentage: "0",
      iddPlusRemediationNotOrderedPercentage: "0",
      iddPlusRemediationGreenPercentage: "0",
      iddPlusRemediationRedPercentage: "0",
      lastTwoMonthData: "",
      lastMonthData: "",
      ajaxPostParameters: {
        companyId: "194",
        startDate: moment()
          .subtract(1, "months")
          .startOf("month"),
        endDate: moment()
          .subtract(1, "months")
          .endOf("month")
      },
      pieChartLabels: {
        showEddAndIddPlus: ["Edd", "Idd+"],
        showRiskAlert: ["Risk", "No Risk"]
      },
      pieChartDatasets: [
        {
          // one line graph
          label: "Number of Orders",
          data: [27, 14],
          backgroundColor: [
            "rgba(54,73,93,.5)", // Blue
            "rgba(71, 183,132,.5)"
          ],
          borderColor: ["#36495d", "#47b784"],
          borderWidth: 3
        }
        // { // another line graph
        //     label: 'Planet Mass (x1,000 km)',
        //     data: [4.8, 12.1, 12.7, 6.7, 139.8, 116.4, 50.7, 49.2],
        //     backgroundColor: [
        //         'rgba(71, 183,132,.5)', // Green
        //     ],
        //     borderColor: [
        //         '#47b784',
        //     ],
        //     borderWidth: 3
        // }
      ],
      pieChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        lineTension: 1
        // scales: {
        //     yAxes: [{
        //         ticks: {
        //             beginAtZero: true,
        //             padding: 25,
        //         }
        //     }]
        // }
      }
    };
  },

  computed: {
    // rows() {
    //   return this.staticItems.length;
    // }
  },
  mounted() {
    this.getAllData(this.ajaxPostParameters);
  },
  filters: {
    convertToFloat(value) {
      return parseFloat(value).toFixed(2);
    },
    date(value) {
      return moment(value).format("DD MMM YYYY");
    }
  },
  methods: {
    async getAllData(parameters) {
      this.thirdPartiesVueContainerParams = parameters;
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");

      try {
        let result = await HTTP("post", "v1/reports/getalldata", parameters, {
          Authorization: token
        });
        this.response = result.data.response;
        this.processData(this.response);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    processData(response) {
      this.ranges = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "This month": [moment().startOf("month"), moment().endOf("month")],
        "This year": [moment().startOf("year"), moment().endOf("year")],
        "Last week": [
          moment()
            .subtract(1, "week")
            .startOf("week"),
          moment()
            .subtract(1, "week")
            .endOf("week")
        ],
        "Last month": [
          moment()
            .subtract(1, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month")
        ],
        "All Time": [moment(response.firstThirdPartyCreatedDate), moment()]
      };
      this.pieChartDatasets[0].data[0] =
        response.totalNumberOfThirdPartiesEDDOrdersWithDateFilter;
      this.pieChartDatasets[0].data[1] =
        response.totalNumberOfThirdPartiesIDDOrdersWithDateFilter;
      this.date_of_report = this.formatDateTime(
        this.dateRange.endDate,
        "DD, MMM YYYY, Z"
      );
      this.lastTwoMonthData = moment()
        .subtract(2, "months")
        .format("MMM YYYY");
      this.lastMonthData = moment()
        .subtract(1, "months")
        .format("MMM YYYY");
      if (
        response.totalThirdPartiesSanctionsWithNoRiskAlert +
          response.totalThirdPartiesSanctionsWithRiskAlert >
        0
      ) {
        this.noRiskAlertFound =
          (response.totalThirdPartiesSanctionsWithNoRiskAlert * 100) /
          (response.totalThirdPartiesSanctionsWithNoRiskAlert +
            response.totalThirdPartiesSanctionsWithRiskAlert);
        this.riskAlertFound =
          (response.totalThirdPartiesSanctionsWithRiskAlert * 100) /
          (response.totalThirdPartiesSanctionsWithNoRiskAlert +
            response.totalThirdPartiesSanctionsWithRiskAlert);
      }
      if (response.thirdPartiesCount > 0) {
        this.lowRiskPercentage =
          (response.thirdPartiesWithLowPRICount * 100) /
          response.thirdPartiesCount;
        this.moderateRiskPercentage =
          (response.thirdPartiesWithModeratePRICount * 100) /
          response.thirdPartiesCount;
        this.highRiskPercentage =
          (response.thirdPartiesWithHighPRICount * 100) /
          response.thirdPartiesCount;
        this.noPriPercentage =
          (response.thirdPartiesWithNoPRICount * 100) /
          response.thirdPartiesCount;
        this.eddOrdersPercentage =
          (response.thirdPartiesWithEddOrders * 100) /
          response.thirdPartiesCount;
        this.eddOrdersWithAlertsPercentage =
          (response.thirdPartiesWithRedEDD * 100) / response.thirdPartiesCount;
        this.iddOrdersPercentage =
          (response.thirdPartiesWithIddOrders * 100) /
          response.thirdPartiesCount;
      }
      if (response.thirdPartiesWithIddOrders > 0) {
        this.iddOrdersWithAlertPercentage =
          (response.thirdPartiesWithIddOrdersWithAlerts * 100) /
          response.thirdPartiesWithIddOrders;
        this.iddOrdersGreenPercentage =
          (response.thirdPartiesWithIddOrdersWithGreenIdd * 100) /
          response.thirdPartiesWithIddOrders;
        this.iddOrdersRedPercentage =
          (response.thirdPartiesWithIddOrdersWithRedIdd * 100) /
          response.thirdPartiesWithIddOrders;
      }
      if (response.thirdPartiesWithIddPlusRedAlertsRemediation > 0) {
        this.iddPlusRemediationPercentage =
          (response.thirdPartiesWithIddPlusRemediationOrdered * 100) /
          response.thirdPartiesWithIddPlusRedAlertsRemediation;
        this.iddPlusRemediationNotOrderedPercentage =
          (response.thirdPartiesWithIddPlusRemediationNotOrdered * 100) /
          response.thirdPartiesWithIddPlusRedAlertsRemediation;
      }
      if (response.thirdPartiesWithIddPlusRemediationOrdered > 0) {
        this.iddPlusRemediationGreenPercentage =
          (response.thirdPartiesWithIddPlusRemediationGreen * 100) /
          response.thirdPartiesWithIddPlusRemediationOrdered;
        this.iddPlusRemediationRedPercentage =
          (response.thirdPartiesWithIddPlusRemediationRed * 100) /
          response.thirdPartiesWithIddPlusRemediationOrdered;
      }
      if (response.thirdPartiesWithEddOrders > 0) {
        this.greenEddRiskPercentage =
          (response.thirdPartiesWithGreenEDD * 100) /
          response.thirdPartiesWithEddOrders;
        this.redEddRiskPercentage =
          (response.thirdPartiesWithRedEDD * 100) /
          response.thirdPartiesWithEddOrders;
      }
    },
    formatDateTime(dateTime, format = "DD, MMM YYYY, Z") {
      // let toUtc = moment.utc(result.data.updated_at.date).format();
      return (
        moment
          .utc(dateTime)
          .local()
          .format(format) + " GMT"
      );
      // "YY-MMM-Do h:mm:ss a" // this will show year, month, day, date 12hr formatt
      //   return moment(toLocal).calendar();
    },
    updateValues(value) {
      this.dateRange.startDate = moment(value.startDate);
      this.dateRange.endDate = moment(value.endDate);
      this.ajaxPostParameters.startDate = this.dateRange.startDate;
      this.ajaxPostParameters.endDate = this.dateRange.endDate;
      this.getAllData(this.ajaxPostParameters);
      // console.log("updateValues: ", value);
    },
    checkOpen(value) {
      // console.log("checkOpen: ", value);
    },
    changeCompany(value) {
      this.selectedCompany = value.company_name;
      this.ajaxPostParameters.companyId = value.id;
      this.getAllData(this.ajaxPostParameters);
      // console.log("changeCompany: ", value.id);
    },
    downloadReport() {
      this.ajaxPostParameters.sort = "comp_name_eng" + "|" + "asc";
      axios({
        url: config.API_URL + "v1/reports/downloadreport",
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        },
        data: this.ajaxPostParameters
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", (this.selectedCompany+".xlsx")); //or any other extension
        document.body.appendChild(link);
        link.click();
      });

      axios({
        url: config.API_URL + "v1/reports/downloadreportdetail",
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        },
        data: this.ajaxPostParameters
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", (this.selectedCompany+" OGM REMEDIATION.xlsx")); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }
  }
};
</script>

<style scoped>
</style>
